<template>
  <div class="new-product-box">
    <div class="new-product-info">
      <div class="carousel-container" @mouseenter="stopAnimation" @mouseleave="startAnimation">
        <div class="carousel-wrapper" ref="wrapper" v-if="dataList.length > 3">
          <div class="product-items" v-for="(sitem, index) in dataList" :key="index">
            <div class="product-img" @click="$router.push({ path: '/proDetail', query: { coNu: sitem.co_Nu } })">
              <img :src="sitem.imgUrl" :alt="sitem.pr_Na" />
            </div>
            <div class="product-txt">
              <h3 @click="$router.push({ path: '/proDetail', query: { coNu: sitem.co_Nu } })">
                {{ language === "en" ? sitem.pr_En_Na : language === "fr" ? sitem.basicThreeLanguage : sitem.pr_Na }}
              </h3>
              <p class="number">{{ sitem.co_Nu }}</p>
              <p class="price">{{ userInfo.symbol }}{{ userInfo.status === 1 ? sitem.price : $t("viewPrice") }}</p>
            </div>
          </div>
          <div class="product-items" v-for="(sitem, index) in dataList" :key="`${index}-copy`">
            <div class="product-img" @click="$router.push({ path: '/proDetail', query: { coNu: sitem.co_Nu } })">
              <img :src="sitem.imgUrl" :alt="sitem.pr_Na" />
            </div>
            <div class="product-txt">
              <h3 @click="$router.push({ path: '/proDetail', query: { coNu: sitem.co_Nu } })">
                {{ language === "en" ? sitem.pr_En_Na : language === "fr" ? sitem.basicThreeLanguage : sitem.pr_Na }}
              </h3>
              <p class="number">{{ sitem.co_Nu }}</p>
              <p class="price">{{ userInfo.symbol }}{{ userInfo.status === 1 ? sitem.price : $t("viewPrice") }}</p>
            </div>
          </div>
        </div>
        <div class="carousel-wrapper2" v-else>
          <div class="product-items" v-for="(sitem, index) in dataList" :key="index">
            <div class="product-img" @click="$router.push({ path: '/proDetail', query: { coNu: sitem.co_Nu } })">
              <img :src="sitem.imgUrl" :alt="sitem.pr_Na" />
            </div>
            <div class="product-txt">
              <h3 @click="$router.push({ path: '/proDetail', query: { coNu: sitem.co_Nu } })">
                {{ language === "en" ? sitem.pr_En_Na : language === "fr" ? sitem.basicThreeLanguage : sitem.pr_Na }}
              </h3>
              <p class="number">{{ sitem.co_Nu }}</p>
              <p class="price">{{ userInfo.symbol }}{{ userInfo.status === 1 ? sitem.price : $t("viewPrice") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="videoDialog">
      <el-dialog :title="$t('LLH.Video_playback')" :visible.sync="dialogVisible" :before-close="handleClose">
        <div class="video-box">
          <video
            ref="videoPlayer"
            :src="videoUrl"
            type="video/mp4"
            style="max-height: 580px; max-width: 100%"
            controls
            autoplay
          ></video>
        </div>
        <span slot="footer" class="dialog-footer"></span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      calleft: 0,
      speed: 1,
      dialogVisible: false,
      videoUrl: "",
    };
  },
  props: ["dataList"],
  created() {
    this.startAnimation();
  },
  computed: {
    // 用户信息
    ...mapState("user", ["userInfo"]),
    // 语言
    ...mapState("operate", ["language"]),
  },
  methods: {
    videItems2(op) {
      console.log("kk");
      this.videoUrl = op;
      this.dialogVisible = true;
    },
    // 关闭视频
    handleClose(done) {
      done();
      this.videoUrl = "";
    },
    startAnimation() {
      this.$nextTick(() => {
        if (this.$refs.wrapper) {
          this.$refs.wrapper.style.animationPlayState = "running";
          // this.$refs.wrapper.style.animationPlayState = "paused";
        }
      });
    },
    stopAnimation() {
      this.$nextTick(() => {
        if (this.$refs.wrapper) {
          this.$refs.wrapper.style.animationPlayState = "paused";
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.new-product-box {
  overflow: hidden;

  .new-product-info {
    width: 1200px;
    height: 367px;
    border-top: 0;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;

    .carousel-wrapper {
      display: flex;
      align-items: center;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      // white-space: nowrap;
      animation: carousel 30s linear infinite;
    }

    .carousel-wrapper2 {
      display: flex;
      align-items: center;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    @keyframes carousel {
      0% {
        transform: translateX(0);
      }

      100% {
        transform: translateX(-50%);
      }
    }
  }
}

.product-items {
  width: 282px;
  margin-right: 24px;
  box-shadow: 0 2px 2px 2px #f5f5f5;
  padding: 15px 0;

  .product-img {
    cursor: pointer;
    width: 90%;
    margin: 0 5% 5% 5%;
    overflow: hidden;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 200px;
      transition-duration: 0.5s;
      &:hover {
        transition-duration: 0.5s;
        transform: scale(1.1);
      }
    }
  }

  .product-txt {
    padding: 0 5%;

    h3 {
      font-size: 16px;
      font-weight: normal;
      height: 60px;
      line-height: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .number {
      font-size: 14px;
      height: 30px;
      line-height: 30px;
    }

    .price {
      font-size: 14px;
      color: #f24141;
      font-weight: bold;
      height: 25px;
      line-height: 25px;
    }
  }

  &:last-child {
    margin-right: 0;
  }
}
</style>
